export const copy = {
  input: {
    ariaLabel: "input",
    placeholder: "Enter a message",
  },
};
